import { MenuMainConstants } from "../../constants/menus-constant";

export const ReportCatalogModulesConstant = {
    role: "role-management",
    user: "user-management",
    participant: "participant-management",
    ruleEngine: "rule-engine-management",
    mcc: "mcc-block-management",
    countryCodeBlock: "country-block-management",
    authentication: "authentication-management",
};

export const ReportCatalogTabsConstant = {
    filters: 1,
    preview: 2,
    exports: 3
};

export const ReportCatalogFormatsConstant = {
    xlsx: 'xlsx',
    pdf: 'pdf',
    csv: 'csv'
};

export const ReportJobsStatusConstant = {
    progress: 'Running',
    complete: 'Ready',
    failed: 'Failed'
};

export const ReportCatalogBlockConstant = {
    global: 1,
    participant: 2,
};

export const ReportCatalogAvailableFormats = [
    ReportCatalogFormatsConstant?.xlsx,
    ReportCatalogFormatsConstant?.pdf,
    ReportCatalogFormatsConstant?.csv
];

export const ReportCatalogAvailableTabs = [
    { label: 'Filters', value: ReportCatalogTabsConstant?.filters },
    { label: 'Preview', value: ReportCatalogTabsConstant?.preview },
    { label: 'Exports', value: ReportCatalogTabsConstant?.exports }
];

export const ReportCatalogModules = (user) => [
    { label: 'Role Management', value: ReportCatalogModulesConstant?.role, permissionUrl: MenuMainConstants?.role },
    { label: 'User Management', value: ReportCatalogModulesConstant?.user, permissionUrl: MenuMainConstants?.user },
    { label: 'Participant Management', value: ReportCatalogModulesConstant?.participant, permissionUrl: MenuMainConstants?.participant },
    { label: 'Rule Engine Management', value: ReportCatalogModulesConstant?.ruleEngine, permissionUrl: MenuMainConstants?.ruleEngine },
    { label: 'MCC Block Management', value: ReportCatalogModulesConstant?.mcc, permissionUrl: user?.permissions?.includes(MenuMainConstants?.mccGlobalBlock) ? MenuMainConstants?.mccGlobalBlock : MenuMainConstants?.mccParticipantBlock },
    { label: 'Country Block Management', value: ReportCatalogModulesConstant?.countryCodeBlock, permissionUrl: user?.permissions?.includes(MenuMainConstants?.countryGlobalBlock) ? MenuMainConstants?.countryGlobalBlock : MenuMainConstants?.countryParticipantBlock },
    { label: 'Authentication History', value: ReportCatalogModulesConstant?.authentication, permissionUrl: MenuMainConstants?.authenticationHistory },
];

export const ReportCatalogBlockOptions = [
    { label: 'Global Level', value: ReportCatalogBlockConstant?.global },
    { label: 'Participant Level', value: ReportCatalogBlockConstant?.participant },
];